import React from 'react';
import { Grid2 as Grid } from '@mui/material';

import { PicturePicker } from '../../../../../Forms';
import { QuestionTypeShowProps } from './QuestionShow';

export default function PictureShow({
  form,
  question,
  errors,
  index,
  setDisabledForm,
  scope,
}: QuestionTypeShowProps) {
  const name = `${scope}answers_attributes.${index}.picture`;
  const { setValue, setError, register, watch } = form;
  const [willDestroy] = watch(['picture_attributes[_destroy]']);
  const picture = watch(name);

  return (
    <Grid container>
      <Grid size={{ xs: 12, md: 6 }}>
        <PicturePicker
          name={name}
          rounded
          recommandedSize={[1200, 800]}
          previewSize={[1200, 800]}
          previewRatio="3:2"
          errors={errors}
          setValue={setValue}
          setError={setError}
          register={register}
          willDestroy={willDestroy}
          pictureS3Key={picture?.s3_key}
          filename={picture?.title}
          setDisabledForm={setDisabledForm}
          required={question.required}
        />
      </Grid>
    </Grid>
  );
}
